import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Spinner, Container } from "react-bootstrap";

const ProtectedRoute = ({
  children,
  adminOnly = false,
  managerOnly = false,
}) => {
  const { currentUser, loading, isAdmin, isManager } = useContext(AuthContext);
  const location = useLocation();

  // Show loading spinner while authentication status is being checked
  if (loading) {
    return (
      <Container
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: "50vh" }}
      >
        <div className="text-center">
          <Spinner animation="border" role="status" variant="primary" />
          <p className="mt-3">Loading...</p>
        </div>
      </Container>
    );
  }

  // Redirect to login if user is not authenticated
  if (!currentUser) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  // Check if route requires admin access
  if (adminOnly && !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  // Check if route requires manager access
  if (managerOnly && !isManager()) {
    return <Navigate to="/" replace />;
  }

  // User is authenticated and has appropriate permissions
  return children;
};

export default ProtectedRoute;
